<template>
  <ProductType
    v-if="types.length"
    :id="productId"
    v-model="selectedTypeId"
    :types="types"
    :class="isSpacingExperimentEnabled ? 'margin-bottom-xs' : 'margin-bottom-m'"
    :label="label || 'Orientation'"
  />
</template>

<script setup>
import { ProductType } from '@common-vue/media-card-large/src/modules/type';
import { useType } from '@modules/types';
import { useExperiments } from '@composables/useExperiments';
import { useProduct } from '@modules/product';

const { productId } = useProduct();
const {
  experimentFlags: { isSpacingExperimentEnabled },
} = useExperiments();
const { types, selectedTypeId, label } = useType();
</script>
